import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminSettingsService } from '../../core/services/admin-settings.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-settings-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './settings-list.component.html'
})
export class SettingsListComponent implements OnInit {
  settings: Record<string, string> = {};
  settingKeys: string[] = [];
  isLoading = false;
  errorMessage = '';

  isSaving = false;

  constructor(private settingsService: AdminSettingsService) {}

  ngOnInit() {
    this.loadSettings();
  }

  loadSettings() {
    this.isLoading = true;
    this.errorMessage = '';

    this.settingsService.getSettings().subscribe({
      next: (res) => {
        this.settings = res || {};
        this.settingKeys = Object.keys(this.settings);
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load settings.';
        this.isLoading = false;
      }
    });
  }

  saveAllSettings() {
    this.isSaving = true;

    const payload = {
      settings: this.settingKeys.map(key => ({
        key: key,
        value: String(this.settings[key])
      }))
    };

    this.settingsService.updateSettings(payload).subscribe({
      next: () => {
        this.isSaving = false;
        alert('Settings updated successfully!');
      },
      error: (err) => {
        this.isSaving = false;
        alert(err?.error?.message ?? 'Failed to update settings.');
      }
    });
  }
}
